import React from 'react';
import PropTypes from 'prop-types';
import MuiTypography from '@mui/material/Typography';

const Typography = ({children, component, variant, className}) => {
    return (
        <MuiTypography
            component={component}
            variant={variant}
            className={className}
        >
            {children}
        </MuiTypography>
    );
};

Typography.propTypes = {
    children: PropTypes.node,
    component: PropTypes.elementType,
    variant: PropTypes.string,
    className: PropTypes.string,
};

export default Typography;
